<template>
  <div v-loading.body="loading">
    <el-row class="promotion-data">
      <el-form :model="promotionData" label-width="150px" ref="promotionData" :rules="rules">
        <el-form-item :label="generateCustomizeString('freeShippingGoodsListUrl')">
          <a :href="mobileUrl + '/free-shipping'" target="_blank">
            <span style="color: #606266;">{{mobileUrl + '/free-shipping'}}</span>
          </a>
        </el-form-item>
        <p style="padding-left: 150px; margin-bottom: 20px; margin-top: -15px; font-size: 12px; color: #606266;">
          {{ generateCustomizeString('onlyShowsFreeShippingGoods') }}
        </p>
        <el-form-item :label="generateCustomizeString('pcFreeShippingGoodsListUrl')">
          <a :href="pcUrl + '/promotion/free-shipping'" target="_blank">
            <span style="color: #606266;">{{pcUrl + '/promotion/free-shipping'}}</span>
          </a>
        </el-form-item>
        <p style="padding-left: 150px; margin-bottom: 20px; margin-top: -15px; font-size: 12px; color: #606266;">
          {{ generateCustomizeString('onlyShowsFreeShippingGoods') }}
        </p>
        <el-form-item :label="generateCustomizeString('limitFreeShippingUrl')" style="margin-top: 30px;">
          <a :href="mobileUrl + '/express-fee-promotion/' + this.promotionData.id" target="_blank">
            <span style="color: #606266;">{{mobileUrl + '/express-fee-promotion/' + this.promotionData.id}}</span>
          </a>
        </el-form-item>
        <p style="padding-left: 150px; margin-bottom: 30px; margin-top: -15px; font-size: 12px; color: #606266;">
          {{ generateCustomizeString('onlyShowsLimitFreeShippingGoods') }}
        </p>
        <el-form-item :label="generateCustomizeString('pcLimitFreeShippingUrl')" style="margin-top: 30px;">
          <a :href="pcUrl + '/promotion/express-fee/' + this.promotionData.id" target="_blank">
            <span style="color: #606266;">{{pcUrl + '/promotion/express-fee/' + this.promotionData.id}}</span>
          </a>
        </el-form-item>
        <p style="padding-left: 150px; margin-bottom: 30px; margin-top: -15px; font-size: 12px; color: #606266;">
          {{ generateCustomizeString('onlyShowsLimitFreeShippingGoods') }}
        </p>
        <el-form-item :label="generateCustomizeString('freeShippingName')" prop="title" style="margin-top: 50px;">
          <el-input v-model="promotionData.title" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('freeShippingCap')" prop="threshold" style="margin-top: 50px;">
          <el-input v-model="promotionData.threshold" style="width: 50%;" onkeyup="value=value.replace(/[^\d.]/g,'')" @change="setTwoNumberDecimal()">
            <template slot="prepend">NZD $</template>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top: 50px;">
          <el-button v-if="isEdit" type="primary" @click="updatePromotion()" plain>{{ generateCustomizeString('update') }}</el-button>
          <el-button v-if="!isEdit" type="primary" @click="createPromotion()" plain>{{ generateCustomizeString('create') }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultPromotionData = {
  id: '',
  title: '满49包邮',
  shop_id: 'shop_id',
  threshold: 49
}

export default {
  name: 'ExpressFeePromotionDetails',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      promotionData: Object.assign({}, defaultPromotionData),
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url,
      rules: {
        title: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        threshold: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    setTwoNumberDecimal(event) {
      if (this.promotionData.threshold) {
        this.promotionData.threshold = parseFloat(this.promotionData.threshold).toFixed(2)
      }
      return ''
    },
    fetchPromotionData() {
      request({
        url: 'activity/freeshipping/' + this.$route.params.promotionId,
        method: 'get'
      })
        .then(response => {
          // const data = response.data
          // this.promotionData = data
          for (const i in this.promotionData) {
            this.promotionData[i] = response.data[i]
            if (i === 'threshold') {
              this.promotionData.threshold = parseFloat(response.data[i] / 100 * 1000 / 1000).toFixed(2)
            }
          }
          console.log(this.promotionData)
        })
        .catch(error => {
          console.warn(error)
        })
    },
    createPromotion() {
      var data = {}
      data = {
        title: this.promotionData.title,
        threshold: this.promotionData.threshold * 100
      }
      request({
        url: 'activity/freeshipping',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.push({
              name: 'FreeExpressFeePromotion'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updatePromotion() {
      var data = {}
      data = {
        title: this.promotionData.title,
        threshold: this.promotionData.threshold * 100
      }
      request({
        url: 'activity/freeshipping/' + this.$route.params.promotionId,
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'FreeExpressFeePromotion'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    }
  },
  created: function() {
    if (location.host.includes('ieshop.co.nz')) {
      const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
      if (this.pcUrl.includes('nzmai.com.cn')) {
        this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
      }
    }

    if (this.isEdit) {
      this.fetchPromotionData()
    } else {
      this.promotionData = Object.assign({}, defaultPromotionData)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.promotion-data {
  padding: 80px 60px 0px 50px;
}
</style>
<!-- <style type="text/css">
  .el-input__icon {
    line-height: 20px;
  }
</style> -->
